/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectInformationResourceFreelancerAppraisalRating
 */
export interface ProjectInformationResourceFreelancerAppraisalRating {
    /**
     * 
     * @type {number}
     * @memberof ProjectInformationResourceFreelancerAppraisalRating
     */
    general?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectInformationResourceFreelancerAppraisalRating
     */
    communication?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectInformationResourceFreelancerAppraisalRating
     */
    delay?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectInformationResourceFreelancerAppraisalRating
     */
    quality?: number;
}

/**
 * Check if a given object implements the ProjectInformationResourceFreelancerAppraisalRating interface.
 */
export function instanceOfProjectInformationResourceFreelancerAppraisalRating(value: object): value is ProjectInformationResourceFreelancerAppraisalRating {
    return true;
}

export function ProjectInformationResourceFreelancerAppraisalRatingFromJSON(json: any): ProjectInformationResourceFreelancerAppraisalRating {
    return ProjectInformationResourceFreelancerAppraisalRatingFromJSONTyped(json, false);
}

export function ProjectInformationResourceFreelancerAppraisalRatingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInformationResourceFreelancerAppraisalRating {
    if (json == null) {
        return json;
    }
    return {
        
        'general': json['general'] == null ? undefined : json['general'],
        'communication': json['communication'] == null ? undefined : json['communication'],
        'delay': json['delay'] == null ? undefined : json['delay'],
        'quality': json['quality'] == null ? undefined : json['quality'],
    };
}

export function ProjectInformationResourceFreelancerAppraisalRatingToJSON(value?: ProjectInformationResourceFreelancerAppraisalRating | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'general': value['general'],
        'communication': value['communication'],
        'delay': value['delay'],
        'quality': value['quality'],
    };
}

